import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Wallet, Banknote, TrendingUp } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip,
  PieChart, Pie, Cell, Legend,
} from "recharts";
import { PageHeader, Spinner, Card, KPICard } from "./_ui";

const COLORS = ["#D4AF37", "#0052CC", "#34D399", "#F87171", "#A78BFA"];

export default function ComptabilitePanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/comptabilite").then((r) => setData(r.data)); }, []);
  if (!data) return (<><PageHeader title="Comptabilité" /><Spinner /></>);

  return (
    <div data-testid="admin-comptabilite">
      <PageHeader
        title="Comptabilité"
        subtitle="Synthèse financière du mouvement A.F.B. en temps réel."
      />

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <KPICard icon={Banknote} label="Total dons (USD)" value={`$${data.total_dons_usd}`} color="green" />
        <KPICard icon={Wallet} label="Total cotisations (USD)" value={`$${data.total_cotisations_usd}`} color="blue" />
        <KPICard icon={TrendingUp} label="Total général (USD)" value={`$${data.total_general_usd}`} color="gold" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card className="lg:col-span-2 p-5">
          <h3 className="text-[15px] font-semibold text-white tracking-tight mb-4">Encaissements par mois</h3>
          <div className="h-[280px]">
            {data.by_month.length === 0 ? (
              <div className="h-full grid place-items-center text-sm text-slate-500">Aucun encaissement.</div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data.by_month}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
                  <XAxis dataKey="month" tick={{ fill: "#94A3B8", fontSize: 11 }} />
                  <YAxis tick={{ fill: "#94A3B8", fontSize: 11 }} />
                  <Tooltip
                    cursor={{ fill: "rgba(255,255,255,0.04)" }}
                    contentStyle={{ background: "#0B1220", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "#E2E8F0", fontSize: 12 }}
                  />
                  <Bar dataKey="amount" fill="#D4AF37" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        </Card>

        <Card className="p-5">
          <h3 className="text-[15px] font-semibold text-white tracking-tight mb-4">Répartition par méthode</h3>
          <div className="h-[280px]">
            {data.by_method.length === 0 ? (
              <div className="h-full grid place-items-center text-sm text-slate-500">Pas encore de données.</div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={data.by_method} dataKey="amount" nameKey="method" innerRadius={50} outerRadius={90}>
                    {data.by_method.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                  </Pie>
                  <Legend wrapperStyle={{ fontSize: 12, color: "#94A3B8" }} />
                  <Tooltip contentStyle={{ background: "#0B1220", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "#E2E8F0", fontSize: 12 }} />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
